import namespace from './namespace';
import { ApiConfig } from './types';

const config: ApiConfig = {
    baseUrl: `https://${namespace}-api.ext.dev.bizzabo.com`,
    authCookieAccess: `x-bz-access-attendee-token-${namespace}`,
    eventsUrl: `https://${namespace}-events.ext.dev.bizzabo.com`,
    previewCookieName: 'x-bz-preview',
    cloudinaryCloudName: 'bizzabo',
    cloudinaryUploadPreset: 'n4w6z5xg',
    snowplowDevelopmentEndpoint: 'com-bizzabo-prod1.mini.snplow.net',
    snowplowProductionEndpoint: 'sp.bizzabo.com',
    snowplowSourceEndpoint: 'https://cdnjs.cloudflare.com/ajax/libs/snowplow/2.16.3/sp.js',
    seismoHost: `${namespace}-seismo.ext.dev.bizzabo.com`,
    realtimeNotificationsHost: `${namespace}-realtimenotifications.ext.dev.bizzabo.com`,
    dashboardUrl: `https://${namespace}-accounts.ext.dev.bizzabo.com`,
    refreshTokenUrl: '/token/refresh',
    livestreamUrl: `https://${namespace}-livestream.ext.dev.bizzabo.com`,
    muxEnvKey: 'k5bsh6ts3t9ebkkruc5qmt3nb',
};

export default config;
